export default "__VITE_ASSET__B_MAl4C5__"